import {Link} from 'react-router-dom'
import Header from '../Header'
import './index.css'

const Home = () => (
  <>
    <Header />
    <div className="home-container">
      <div className="home-text-container">
        <h1 className="home-header">Find The Job That Fits Your Life</h1>
        <p className="home-text">
          Millions of people are searching for jobs,salary information,company
          reviews. Find the job that fits your abilities and potential
        </p>
      </div>
      <Link to="/jobs" className="link-button">
        <button type="button" className="find-job-button">
          Find Jobs
        </button>
      </Link>
    </div>
  </>
)

export default Home
